import {makeStyles} from '@material-ui/core/styles';
import {Box, Button, Grid, Typography} from '@mui/material';
import React from 'react';
import {QuoteFormElement} from '../../shared/QuoteFormElement';

const useSearchAgencyFieldStyles = makeStyles(theme => ({
  inputContainer: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },
  textField: {
    flex: 1,
    height: '40px',
    fontWeight: 500,
    lineHeight: '40px',

    '& .MuiInputBase-root': {
      borderRadius: 0,
    },
  },
  button: {
    marginTop: '3px !important',
    height: '40px',
    minWidth: 120,
    padding: '0 14px',
    borderRadius: '0 !important',
    fontWeight: 500,
    lineHeight: '40px',
    width: '50%',
    backgroundColor: '#ffffff',
    color: '#817e7e',
    cursor: 'not-allowed',
    '&.Mui-disabled': {
      backgroundColor: '#f5f5f5',
      color: '#d9d9d9',
      cursor: 'not-allowed',
    },
  },
}));

export const SearchAgencyField = ({agencyName}: {agencyName: string}) => {
  const classes = useSearchAgencyFieldStyles();

  return (
    <Grid item xs={12} sm={4}>
      <Typography style={{color: '#474747', fontSize: '0.875rem', lineHeight: '1.05rem'}}>
        Producer <span style={{color: '#f44336'}}>*</span>{' '}
      </Typography>
      <Box className={classes.inputContainer}>
        <QuoteFormElement
          elementType="Text"
          id="quote-tech-fee"
          value={agencyName}
          disabled
          required
          className={classes.textField}
        />
        <Button variant="contained" color="primary" size="small" disabled className={classes.button}>
          Search Agency
        </Button>
      </Box>
    </Grid>
  );
};
